import { render } from "./HeroFallback.vue?vue&type=template&id=09a670c1&scoped=true"
import script from "./HeroFallback.vue?vue&type=script&lang=js"
export * from "./HeroFallback.vue?vue&type=script&lang=js"

import "./HeroFallback.vue?vue&type=style&index=0&id=09a670c1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09a670c1"]])

export default __exports__